import { instanceBo } from "../utils/axios.create";
import {
	AuditlogPayload,
	AuditlogResponseBody,
	AuditlogParam,
	AuditlogPaginated,
} from "../domain/auditlog.interface";

const create = async (data: AuditlogPayload): Promise<AuditlogResponseBody> => {
	return instanceBo
		.post("/audittrails", data)
		.then((res) => res.data.body)
		.catch((err) => Promise.reject(err.response?.data || err));
};

const findByModule = async (
	data: AuditlogParam,
): Promise<AuditlogPaginated> => {
	// Encoded: a module name with "&" ("Cups & Analytes", SIMS-8861) otherwise splits the query
	// and the server reads a different module than the entries were written under.
	const q = encodeURIComponent;
	return instanceBo
		.get(
			`/audittrails?module=${q(data.module)}&from=${q(data.from)}&to=${q(data.to)}&pageNumber=${data.pageNumber}&pageSize=${data.pageSize}${data.lastDocId ? "&lastDocId=" + q(data.lastDocId) : ""}`,
		)
		.then((res) => res.data.body)
		.catch((err) => Promise.reject(err.response?.data || err));
};

export const auditlogService = {
	create,
	findByModule,
};
